import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import {
    AccountIdentity,
    accountIdentityFromAuthUser,
    accountIdentityFromEmail,
} from "@/mappers/user/accountIdentityMapper";
import authStore from "@/stores/authStore";
import { useAuthContext } from "@cs_teamwaydev/mailvista-sdk_react";
import { useStore } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";
import NoLicenseView from "./NoLicenseView";
import OffersButton from "./OffersButton";

const B2CNotAllowedScreen = () => {
    const { t } = useTranslation();
    const { getUser } = useAuthContext();
    const userEmail = useStore(authStore, (state) => state.userEmail);

    let account: AccountIdentity;
    try {
        account = accountIdentityFromAuthUser(getUser());
    } catch {
        account = accountIdentityFromEmail(userEmail ?? "");
    }

    return (
        <NoLicenseView
            account={account}
            accountAction={
                <LogoutEscapeLink
                    className="shrink-0 text-purple-700"
                    variant="link"
                />
            }
            cta={<OffersButton />}
            description={t("noLicense.public.description")}
            title={t("noLicense.public.title")}
        />
    );
};

export default B2CNotAllowedScreen;
